<template>
	<div class="xl:container mx-auto gap-[80px]">
		<BlogContainer>
			<template #aside>
				<!-- <TimothyBioPreview class="mb-[32px]" /> -->
			</template>
			<template #main>
				<Heading
					v-if="pageTitle"
					:text="pageTitle"
					tag="h1"
				/>
				<div class="content">
					<p>
						Please reach out to us. All of our departments are happy to assist you.
					</p>

					<Divider />

					<h2>General Inquiries</h2>
					<p>
						For general inquiries about our website, subscriptions, or services,
						contact
						<a href="mailto:support-alerts@timothysykes.com">
							support-alerts@timothysykes.com
						</a>
						.
					</p>

					<p>
						Want to talk? Call our general support team at
						<a
							href="tel:1-888-878-3621"
							class="external-link"
						>
							1-888-878-3621
						</a>
						.
					</p>

					<Divider />

					<h2>Press</h2>
					<b class="mb-4 d-block">
						<p style="margin-bottom: 24px !important">Want to work with Tim?</p>
					</b>

					<p>
						To feature Tim on your podcast, video, or social media, contact
						<br class="hidden xl:block" />

						<a
							href="mailto:press@timothysykes.com"
							class="external-link"
						>
							press@timothysykes.com
						</a>
						.
					</p>

					<p>
						For affiliate links or advertising inquiries, contact
						<a
							href="mailto:advertising@timothysykes.com"
							class="external-link"
						>
							advertising@timothysykes.com
						</a>
						.
					</p>

					<br class="d-block" />

					<h2>Editorial</h2>

					<p>Questions or comments about our editorial?</p>

					<p>
						To report editorial errors or concerns, please contact
						<a
							href="mailto:editorial@timothysykes.com"
							class="external-link"
						>
							editorial@timothysykes.com
						</a>
						.
					</p>

					<Divider />

					<h2>Connect With Us</h2>
					<p>
						Join our exclusive trading community on Facebook here 👉
						<a
							target="_blank"
							href="https://bit.ly/3D012FY"
							class="external-link"
						>
							https://bit.ly/3D012FY
						</a>
						.
					</p>

					<p>
						Stay up to date on Tim Sykes’ trading and charity work on Instagram here
						👉
						<a
							target="_blank"
							href="https://www.instagram.com/timothysykes/"
							class="external-link"
						>
							https://www.instagram.com/timothysykes/
						</a>
						.
					</p>

					<p>
						Follow Tim on Twitter here 👉
						<a
							target="_blank"
							href="https://twitter.com/timothysykes"
							class="external-link"
						>
							https://twitter.com/timothysykes
						</a>
						.
					</p>
					<h2>Address</h2>
					<p>
						Millionaire Media LLC
						<br class="d-block" />
						66 W. Flagler St.
						<br class="d-block" />
						Ste 900
						<br class="d-block" />
						Miami, FL 33130
						<br class="d-block" />
						United States
						<br class="d-block" />
					</p>
				</div>
			</template>
		</BlogContainer>
	</div>

	<Head>
		<Title>Contact TIM - Timothy Sykes Training Program - Timothy Sykes</Title>
		<Link
			rel="canonical"
			:href="`${current_hostname}${pageSlug}/`"
		/>
	</Head>
</template>
<script setup>
import Heading from "~/components/Heading.vue";

// Fetches title, canonical, and Yoast JSON-LD from S3 via /api/dictionary/pages.
// The hardcoded Organization schema below is kept as additional structured data.
const { pageTitle } = await useLegalPage("contact");

const $config = useRuntimeConfig();

const schema = {
	"@context": "https://schema.org",
	"@type": "Organization",
	name: "Timothy Sykes",
	url: "https://www.timothysykes.com",
	description: "How To Trade Penny Stocks Without The Stock Promoter BS",
	disambiguatingDescription:
		"A leading provider of investment education and resources, founded in 2005.",
	foundingDate: "2005-01-15", // Boilerplate text
	logo: {
		"@type": "ImageObject",
		url: $config.public.hostname + "images/ts-logo-icon.png",
		width: 512,
		height: 512
	},
	image: {
		"@type": "ImageObject",
		url: $config.public.hostname + "images/ts-logo-white-bg.png",
		width: 503,
		height: 95
	},
	sameAs: [
		"https://en.wikipedia.org/wiki/Timothy_Sykes",
		"https://www.youtube.com/@TimothySykesTrader",
		"https://www.facebook.com/timsykesfans/",
		"https://twitter.com/timothysykes",
		"https://www.linkedin.com/in/timothysykes/",
		"https://www.instagram.com/timothysykes/",
		"https://www.tiktok.com/@timothysykes",
		"https://profit.ly/user/timothysykes"
	],
	contactPoint: [
		{
			"@type": "ContactPoint",
			contactType: "customer service",
			telephone: "+1-888-878-3621",
			email: "support-alerts@timothysykes.com",
			areaServed: "US",
			availableLanguage: ["English", "Spanish"]
		},
		{
			"@type": "ContactPoint",
			contactType: "media inquiries",
			telephone: "+1-800-878-3621",
			email: "press@timothysykes.com",
			areaServed: "US",
			availableLanguage: ["English"]
		}
	],
	address: {
		"@type": "PostalAddress",
		streetAddress: "66 W. Flagler St. - Suite 900",
		addressLocality: "Miami",
		addressRegion: "FL",
		postalCode: "33130",
		addressCountry: "US"
	},
	founder: {
		"@type": "Person",
		name: "Timothy Sykes",
		url: "https://www.timothysykes.com/blog/author/tim-sykes/",
		sameAs: [
			"https://www.youtube.com/@TimothySykesTrader",
			"https://en.wikipedia.org/wiki/Timothy_Sykes",
			"https://profit.ly/user/timothysykes",
			"https://www.facebook.com/timsykesfans/",
			"https://twitter.com/timothysykes",
			"https://www.linkedin.com/in/timothysykes/",
			"https://www.instagram.com/timothysykes/",
			"https://www.tiktok.com/@timothysykes",
			"https://www.imdb.com/name/nm2418506/",
			"https://observer.com/author/timothy-sykes/",
			"https://books.apple.com/us/author/timothy-sykes/id281184034",
			"https://www.huffpost.com/author/tim-501",
			"https://fortune.com/author/timothy-sykes/",
			"https://www.entrepreneur.com/author/timothy-sykes",
			"https://www.goodreads.com/author/list/748145.Timothy_Sykes",
			"https://www.amazon.com/stores/author/B002BLQ4YC",
			"https://www.businessinsider.com/author/timothy-sykes",
			"https://www.theguardian.com/profile/timothy-sykes"
		],
		image: [
			{
				"@type": "ImageObject",
				url: "https://content.timothysykes.com/wp-content/uploads/2024/08/timsykes.webp",
				width: 306,
				height: 384
			},
			{
				"@type": "ImageObject",
				url: "https://secure.gravatar.com/avatar/092522e87ab76a4bb688d6bfdc0b4f2e?s=96&d=mm&r=g",
				height: 96,
				width: 96
			}
		]
	},
	award: ["Timothy Sykes Day Trading Award for the Talented"],
	publishingPrinciples: "https://www.timothysykes.com/editorial-guidelines/"
};

useHead({
	script: [
		{
			type: "application/ld+json",
			class: "saswp-schema-markup-output",
			innerHTML: JSON.stringify(schema)
		}
	]
});
</script>
<style lang="scss" scoped>
.content h2 {
	color: #1e293b;
	font-family: Fira Sans;
	font-size: 28px;
	font-style: normal;
	font-weight: 700;
	letter-spacing: -0.76px;
	line-height: 120%;
	margin-bottom: 32px;
}

.content a {
	color: #3b82f6;
}

.content p {
	color: #1e293b;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
	margin-bottom: 32px;
}

@media (min-width: 1024px) {
	.content h2 {
		font-size: 38px;
	}
}
</style>
